<template>
  <div class="container">
    <div id="text">
      <h1>使用条款</h1>
      <p>感谢您使用 Graph Editor，您的支持让我们更有动力完善这个产品。Graph Editor 没有资本或公司的支持，我们致力于以一个很小的独立团队为用户带来最佳体验。</p>
      <p class="em">定价策略</p>
      <p>Graph Editor 的核心功能是创建和编辑 Graph，免费用户可以创建有限数量的 Graph 文件，体验 Graph Editor 的便利性。我们也提供 Graph Editor 专业版，旨在满足专业用户更多定制化的需求，同时维持我们的开发工作。</p>
      <p>Graph Editor 专业版提供多种定价策略以适应不同的需求，例如按月订阅、按年订阅，其中订阅制提供免费全功能试用时长。</p>
      <p>另外值得一提的是，若使用订阅模式，您所使用的优惠价格将在续订中保持，不会随着之后产品的价格上调而上调。而永久解锁则对后续所有更新均有效，包括大版本更新。</p>
      <p>如果您感兴趣，请在我们的官网了解更多，感谢支持。</p>
      <p class="em">服务可用性</p>
      <p>当您在多台设备上使用同一 Apple ID 时，请遵循 Apple 官方在《Apple 媒体服务条款和条件》文件中提到的设备数量要求。</p>
      <p>我们保留对严重违反该条款的处理权利，包括但不限于移除已解锁的内容。</p>
      <p class="em">退款</p>
      <p>如果您有这样的想法，我们感到很遗憾，所以请优先考虑通过联系我们来解决您不满的地方，但我们始终尊重您的选择。然而，应用的退款流程并不受开发者掌控，所以我们建议您联系 Apple 的支持团队来处理退款，您可以在这里找到相关信息。</p>
      <p class="em">本使用条款的变更</p>
      <p>我们可能会不时地更新我们的使用条款。因此，建议您定期查看此页面以了解更新后的内容。我们会通过在此页面上发布新的使用条款来通知您任何更改。这些更改在此页面上发布后立即生效。</p>
      <p class="em">联系我们</p>
      <p>如果您对我们的使用条款有任何疑问或建议，请随时通过 askrsw@163.com 与我们联系。</p>
    </div>
    <div id="location">
      <label>中国·山东</label>
    </div>
    <div id="copyright">
      <label>Copyright &copy; 2022 Haharsw</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GraphEditorUserUsageZh'
}
</script>

<style scoped>
.container {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 20px;
}
#text {
  margin: 0 auto;
  font-weight: normal;
  font-size: 20px;
  margin-top: 40px;
  margin-bottom: 20px;
  max-width: 800px;
  text-align: left;
}
#text p {
  margin: 0 auto;
  margin-top: 10px;
}
.em {
  font-weight: bold;
  font-size: 25px;
  margin-top: 15px;
}
.clear{ clear:both}
#location {
  font-weight: normal;
  font-size: 16px;
  margin-top: 60px;
  margin-bottom: 10px;
  text-align: center;
}
#copyright {
  font-weight: normal;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 40px;
  text-align: center;
}
</style>
